import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Account, User } from '../models';
import { fromAccounts, useAppDispatch } from '../store';

export const useGetG2Accounts = (
  user: User | null,
) => {
  const dispatch = useAppDispatch();
  const accLoading = useSelector(fromAccounts.selectLoading);
  const g2Fetching = useSelector(fromAccounts.selectG2Fetching);
  const g2Accounts = useSelector(fromAccounts.selectUserG2Accounts);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user) {
      dispatch(fromAccounts.doGetG2Accounts({ id: user.id }));
    }
  }, [user]);

  const [acc, setAcc] = useState<Account[]>([]);

  useEffect(() => {
    if (!accLoading && !g2Fetching) {
      setAcc(g2Accounts);
      setLoading(false);
    }
  }, [accLoading, g2Fetching]);
  return { g2Accounts: acc, g2Loading: loading };
};

export const useGetG3Accounts = (
  user: User | null,
) => {
  const dispatch = useAppDispatch();
  const accLoading = useSelector(fromAccounts.selectLoading);
  const g3Fetching = useSelector(fromAccounts.selectG3Fetching);
  const total = useSelector(fromAccounts.selectTotal);
  const g3Accounts = useSelector(fromAccounts.selectUserAccounts);
  const [loading, setLoading] = useState(true);

  const [acc, setAcc] = useState<Account[]>([]);
  useEffect(() => {
    if (user) {
      dispatch(fromAccounts.doGetUserAccount({ id: user.id }));
    }
  }, [user]);

  useEffect(() => {
    if (user && !accLoading && g3Fetching && total > g3Accounts.length) {
      dispatch(fromAccounts.doGetUserAccount({ id: user.id, offset: g3Accounts.length }));
    }
  }, [g3Accounts]);

  useEffect(() => {
    if (!accLoading && !g3Fetching) {
      setAcc(g3Accounts.filter(acc => acc.g3));
      setLoading(false);
    }
  }, [g3Fetching]);

  return { g3Accounts: acc, g3Loading: loading };
};
